/*
  De tas naar Gymshark, en de verzenddatum in het stapelkortingblok.

  Bovenop Broadcast en zonder theme.js aan te raken:
  - "Add a little extra" vullen met Shopify's aanbevelingen voor het laatst
    toegevoegde product (sectie api-tas-extra).
  - "Dispatched by ..." op de productpagina: de eerstvolgende werkdag, in
    Londense tijd. De winkelpagina's beloven klaarmaken binnen 0 tot 1 werkdag.
  - "What is my size?" als link naast "Size", naar Gymshark.
*/
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ── Add a little extra ─────────────────────────────────────────── */
  function vulExtra() {
    var blok = document.querySelector('[data-tas-extra]');
    var rij = document.querySelector('[data-tas-extra-rij]');
    if (!blok || !rij) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) { blok.hidden = true; return null; }
        var id = cart.items[0].product_id;
        /* Ook bij hetzelfde product opnieuw ophalen: de sectie laat weg
           wat al in de tas ligt, dus een net toegevoegd stuk valt eruit. */
        return fetch(root + 'recommendations/products?section_id=api-tas-extra&limit=10&product_id=' + id)
          .then(function (r) { return r.ok ? r.text() : ''; });
      })
      .then(function (html) {
        if (html == null) return;
        var houder = document.createElement('div');
        houder.innerHTML = html;
        var antwoord = houder.querySelector('[data-tas-extra-antwoord]');
        var kaarten = antwoord ? antwoord.innerHTML.trim() : '';
        rij.innerHTML = kaarten;
        blok.hidden = !kaarten;
      })
      .catch(function () { blok.hidden = true; });
  }

  document.addEventListener('theme:cart:change', vulExtra);
  document.addEventListener('theme:cart-drawer:open', vulExtra);

  /* ── "+ Add" in de tas: maat kiezen in de kaart zelf ─────────────
     Broadcast opent bij een product met maten de volledige snelkoop: grote
     foto, titel, prijs, en de maten onder de vouw - en de tas gaat dicht. In
     de tas wil je met zo min mogelijk stappen toevoegen, dus zoals Gymshark:
     de knop klapt in de kaart een rij maten open, één tik voegt toe en de
     tas blijft open. De klik wordt in de capture-fase afgevangen, vóór de
     eigen luisteraar van <quick-add-product> op de knop. */
  function geld(centen) {
    var munt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: munt }).format(centen / 100);
  }

  function voegToe(id, knop, kaart) {
    if (knop) knop.disabled = true;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'error');
        var items = document.querySelector('cart-items');
        if (items && typeof items.getCart === 'function') items.getCart();
      })
      .catch(function (err) {
        if (knop) knop.disabled = false;
        var m = kaart && kaart.querySelector('.tas-maten__melding');
        if (m) m.textContent = String(err.message || "Couldn't add this piece. Try again.");
      });
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('.tas-extra .product-upsell__btn');
    if (!knop) return;
    e.preventDefault();
    e.stopPropagation();
    var kaart = knop.closest('.product-upsell__holder');
    var open = kaart.querySelector('.tas-maten');
    if (open) { open.remove(); kaart.classList.remove('is-maten'); return; }
    var handle = knop.getAttribute('data-quick-add-modal-handle');
    /* Eén variant (geen maatkeuze): Broadcast zet dan geen handle. Het
       variant-id staat in het formulier van de kaart. */
    if (!handle) {
      var veld = kaart.querySelector('[name="id"]');
      if (veld) voegToe(veld.value, knop, kaart);
      return;
    }
    knop.disabled = true;
    fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        knop.disabled = false;
        var mi = p.options.findIndex(function (o) { return /^(size|maat|waist)$/i.test(o.name || o); });
        var rij = document.createElement('div');
        rij.className = 'tas-maten';
        rij.innerHTML = '<p class="tas-maten__kop">Select a size</p><div class="tas-maten__knoppen"></div><p class="tas-maten__melding" aria-live="polite"></p>';
        var houder = rij.querySelector('.tas-maten__knoppen');
        p.variants.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'tas-maten__maat';
          b.textContent = mi >= 0 ? v.options[mi] : v.title;
          b.disabled = !v.available;
          b.setAttribute('aria-label', 'Add size ' + b.textContent + ', ' + geld(v.price));
          b.addEventListener('click', function () {
            houder.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
            b.classList.add('is-bezig');
            voegToe(v.id, null, kaart).then(function () {
              houder.querySelectorAll('button').forEach(function (x, i) { x.disabled = !p.variants[i].available; });
              b.classList.remove('is-bezig');
            });
          });
          houder.appendChild(b);
        });
        kaart.appendChild(rij);
        kaart.classList.add('is-maten');
        rij.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      })
      .catch(function () { knop.disabled = false; });
  }, true);

  /* ── Verzenddatum ───────────────────────────────────────────────── */
  function verzenddatum() {
    var plekken = document.querySelectorAll('[data-tas-verzend]');
    if (!plekken.length) return;
    /* Vandaag in Londen als kalenderdag; daarna de eerste werkdag erna. */
    var delen = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(new Date());
    var get = function (t) { return +delen.filter(function (p) { return p.type === t; })[0].value; };
    var d = new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12));
    do { d.setUTCDate(d.getUTCDate() + 1); } while (d.getUTCDay() === 0 || d.getUTCDay() === 6);
    var tekst = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'long' }).format(d);
    plekken.forEach(function (el) { el.textContent = tekst.replace(',', ''); });
  }

  /* ── "What is my size?" naast "Size" ─────────────────────────────
     De link in de legenda opent de bestaande maatwijzer. Zijn eigen knop
     staat verborgen (CSS) maar blijft het startpunt, zodat brand-buy-area en
     de maatwijzer zelf niets hoeven te weten. Zegt de maatwijzer na het
     invullen "Your size: M", dan neemt de link die tekst over. */
  function maatLink() {
    var opener = document.querySelector('[data-maatwijzer-open]');
    document.querySelectorAll('[data-maatwijzer-doorgeef]').forEach(function (link) {
      link.hidden = !opener || !!link.closest('dialog');
    });
    var tekst = document.querySelector('[data-maatwijzer-openertekst]');
    if (!tekst) return;
    var neem = function () {
      document.querySelectorAll('[data-maatwijzer-doorgeef]').forEach(function (l) { l.textContent = tekst.textContent; });
    };
    neem();
    new MutationObserver(neem).observe(tekst, { childList: true, characterData: true, subtree: true });
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-maatwijzer-doorgeef]');
    if (!link) return;
    var opener = document.querySelector('[data-maatwijzer-open]');
    if (opener) { e.preventDefault(); opener.click(); }
  });

  /* ── Geen vooraf gekozen maat ─────────────────────────────────────
     Broadcast vinkt de eerste leverbare maat aan, dus wie niet kijkt bestelt
     S (CRO-audit 14-10-2026; ASOS en Next laten ook eerst kiezen). Zonder
     ?variant= gaat het vinkje eruit en houdt de koopknop een toevoeging
     zonder maat tegen. Met ?variant= (een Shopping-advertentie voor die maat)
     blijft de maat staan. Het verborgen id-veld houdt de startvariant; dat
     is pas erg bij toevoegen, en dat vangt de knop hier af. Een tik op een
     maat (bovenaan, in de sticky balk of via de maatwijzer) is een echte
     change, zodat Broadcast de variant daarna gewoon zelf zet. */
  function geenVasteMaat() {
    if (/[?&]variant=/.test(location.search)) return;
    /* Pas na Broadcasts product-form (17-10-2026). Dit script staat in
       theme.liquid vóór theme.js en draait dus eerder. Zonder dit wachten
       las het formulier "kleur, geen maat", koos de eerste maat van die
       kleur en zette de knop op Sold Out als die maat op was (puffer: alleen
       Brown M-XXL leverbaar). Nu start het formulier op de leverbare
       variant en gaat daarna alleen het vinkje eruit. */
    customElements.whenDefined('product-form').then(function () {
      [].forEach.call(document.querySelectorAll('.selector-wrapper--size'), function (blok) {
        if (blok.closest('#cart-bar') || blok.closest('dialog')) return;
        maatVrij(blok, document);
      });
    });
  }

  /* Quick add op collectiepagina's (17-10-2026, zijn melding): de dialoog
     had dezelfde vooraf gekozen S en voegde die zonder vragen toe. Broadcast
     zet de dialoog pas bij de eerste klik in de pagina en hergebruikt hem
     daarna, dus per dialoog één keer, en nooit opnieuw leeg bij heropenen:
     wie al een maat koos houdt die. ?variant= van de collectiepagina telt
     hier niet; die hoort bij de pagina, niet bij dit product. */
  document.addEventListener('theme:quick-add:open', function () {
    setTimeout(function () {
      [].forEach.call(document.querySelectorAll('[data-quick-add-modal][open] .selector-wrapper--size'), function (blok) {
        maatVrij(blok, blok.closest('[data-quick-add-modal]'));
      });
    }, 0);
  });

  function maatVrij(blok, binnen) {
      if (blok.hasAttribute('data-maat-vrij')) return;
      var radios = blok.querySelectorAll('input[type=radio]');
      if (radios.length < 2) return;
      var atc = [].filter.call(binnen.querySelectorAll('.product__submit__buttons [data-add-to-cart]'), function (k) {
        return !k.closest('#cart-bar') && (binnen !== document || !k.closest('dialog')) && k.form && k.form.getAttribute('id') === radios[0].getAttribute('form');
      })[0];
      if (!atc) return;
      blok.setAttribute('data-maat-vrij', '');
      [].forEach.call(radios, function (r) { r.checked = false; });
      /* "Size:" zonder waarde tot er gekozen is (17-10-2026, Harrington-opmaak). */
      var waarde = blok.querySelector('.radio__legend__value--size');
      if (waarde) waarde.textContent = '';
      var fout = document.createElement('p');
      fout.className = 'maatkeuze__fout';
      fout.setAttribute('role', 'alert');
      fout.hidden = true;
      fout.textContent = 'Please select a size';
      blok.appendChild(fout);
      var zonderMaat = function () {
        return ![].some.call(radios, function (r) { return r.checked; });
      };
      var tegenhouden = function (e, express) {
        if (!zonderMaat()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        /* Op de productpagina een maatkiezer in plaats van alleen een rode
           melding (17-10-2026, zijn wens): de rode rand oogde als een fout.
           In de quick-add-dialoog blijft de melding, een dialoog in een
           dialoog werkt daar niet prettig. */
        if (binnen === document && window.HTMLDialogElement) { maatKiezer(express); return; }
        fout.hidden = false;
        /* Rode rand en een korte schud (concept 17-10-2026): alleen tekst
           onder de knoppen viel niet op. Klasse eraf en weer erop zodat de
           schud bij elke tik opnieuw speelt. */
        blok.classList.remove('is-maat-fout');
        void blok.offsetWidth;
        blok.classList.add('is-maat-fout');
        var rect = blok.getBoundingClientRect();
        if (rect.top < 80 || rect.bottom > window.innerHeight) blok.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
      /* Op document in de capture-fase: Broadcast luistert al op het
         formulier zelf, en een luisteraar daar zou na de zijne komen. */
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-add-to-cart]') === atc) tegenhouden(e);
        /* Express-knop (Shop Pay / Apple Pay / Google Pay, 17-10-2026): die rekent
           de variant in het formulier af, en zonder gekozen maat is dat de eerste
           maat. Dus ook hier eerst een maat laten kiezen. */
        var express = e.target.closest && e.target.closest('.shopify-payment-button');
        if (express && atc.form && atc.form.contains(express)) tegenhouden(e, true);
      }, true);
      document.addEventListener('submit', function (e) {
        if (e.target === atc.form) tegenhouden(e);
      }, true);
      blok.addEventListener('change', function () { fout.hidden = true; blok.classList.remove('is-maat-fout'); });

      /* Kleur wisselen zonder maat (21-10-2026, zijn melding op de puffer):
         Broadcast las "kleur, geen maat", pakte de eerste maat van die kleur
         en zette de knop op Sold Out - Notify me als die maat op was (S is
         daar in elke kleur op). Nu vóór Broadcast een leverbare maat van de
         nieuwe kleur aanvinken, hem de variant laten zetten, en daarna
         alleen het vinkje er weer uit, net als bij het laden. */
      var houder = blok;
      while (houder && !houder.querySelector('[data-product-json]')) houder = houder.parentElement;
      var product = null;
      try { product = houder && JSON.parse(houder.querySelector('[data-product-json]').textContent); } catch (e) {}
      document.addEventListener('change', function (e) {
        var r = e.target;
        if (!product || !zonderMaat() || r.type !== 'radio' || blok.contains(r)) return;
        if (r.getAttribute('form') !== radios[0].getAttribute('form') || !/^option\d$/.test(r.dataset.index || '')) return;
        var v = product.variants.filter(function (x) { return x.available && x[r.dataset.index] === r.value; })[0];
        var m = v && [].filter.call(radios, function (x) { return x.value === v[radios[0].dataset.index]; })[0];
        if (!m) return;
        m.checked = true;
        setTimeout(function () {
          [].forEach.call(radios, function (x) { x.checked = false; });
          if (waarde) waarde.textContent = '';
        }, 0);
      }, true);

      /* Maatkiezer: elke keer opnieuw opgebouwd, want welke maten leverbaar
         zijn hangt af van de gekozen kleur. Een tik op een maat klikt het
         echte label (zoals de sticky balk), zodat Broadcast de variant zet;
         daarna gaat hij via de koopknop de tas in. Bij de express-knop
         (Shop Pay, Apple Pay) alleen de maat zetten: die betaalknop moet de
         bezoeker zelf opnieuw indrukken, opnieuw starten kan niet namens hem. */
      function maatKiezer(express) {
        var d = document.createElement('dialog');
        d.className = 'maatkiezer';
        d.setAttribute('aria-labelledby', 'maatkiezer-titel');
        d.innerHTML = '<div class="maatkiezer__paneel"><div class="maatkiezer__kop"><p class="maatkiezer__titel" id="maatkiezer-titel">Select your size</p>' +
          '<button type="button" class="maatkiezer__sluit" aria-label="Close">&times;</button></div>' +
          '<div class="maatkiezer__maten"></div>' +
          (document.querySelector('[data-maatwijzer-open]') ? '<button type="button" class="maatkiezer__gids">Not sure? Find your size</button>' : '') + '</div>';
        var rij = d.querySelector('.maatkiezer__maten');
        [].forEach.call(radios, function (r) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'maatkiezer__maat';
          b.textContent = r.value;
          b.disabled = r.disabled || r.classList.contains('sold-out') || r.classList.contains('unavailable');
          b.addEventListener('click', function () {
            var label = blok.querySelector('label[for="' + r.id + '"]');
            (label || r).click();
            d.close();
            if (!express) setTimeout(function () { atc.click(); }, 250);
          });
          rij.appendChild(b);
        });
        d.querySelector('.maatkiezer__sluit').addEventListener('click', function () { d.close(); });
        var gids = d.querySelector('.maatkiezer__gids');
        if (gids) gids.addEventListener('click', function () { d.close(); document.querySelector('[data-maatwijzer-open]').click(); });
        /* Tik op de achtergrond sluit ook */
        d.addEventListener('click', function (ev) { if (ev.target === d) d.close(); });
        d.addEventListener('close', function () { d.remove(); });
        document.body.appendChild(d);
        d.showModal();
      }
  }

  /* ── Sticky koopbalk (zie snippets/brand-sticky-koop.liquid) ───── */
  function stickyKoop() {
    var balk = document.querySelector('[data-sticky-koop]');
    if (!balk) return;
    var buiten = function (el) { return !el.closest('#cart-bar') && !el.closest('dialog'); };
    var maatBlok = [].filter.call(document.querySelectorAll('.selector-wrapper--size'), buiten)[0];
    var atc = [].filter.call(document.querySelectorAll('.product__submit__buttons [data-add-to-cart]'), buiten)[0];
    var prijsEl = [].filter.call(document.querySelectorAll('[data-product-price]'), buiten)[0];
    var knop = balk.querySelector('[data-sticky-knop]');
    var rij = balk.querySelector('[data-sticky-maten]');
    if (!atc) { balk.hidden = true; return; }
    /* Een vooraf aangevinkte maat telt niet als keuze: pas na een tik van
       de bezoeker (bovenaan of hier) zet de knop de maat erin. */
    var gekozen = !maatBlok, wijzigt = false;
    var radios = function () { return maatBlok ? [].slice.call(maatBlok.querySelectorAll('input[type=radio]')) : []; };
    var prijs = function () { return prijsEl ? prijsEl.textContent.trim().replace(/\s+GBP$/, '') : ''; };
    function teken() {
      var r = radios().filter(function (x) { return x.checked; })[0];
      if (atc.disabled) { knop.textContent = 'Sold out'; knop.disabled = true; return; }
      knop.disabled = false;
      if (gekozen) knop.textContent = 'Add to bag' + (r ? ' · ' + r.value : '') + (prijs() ? ' · ' + prijs() : '');
      else knop.textContent = 'Select size';
    }
    if (maatBlok) maatBlok.addEventListener('change', function (e) {
      if (e.isTrusted || wijzigt) { gekozen = true; }
      setTimeout(teken, 50);
    });
    function sluit() { rij.hidden = true; rij.innerHTML = ''; balk.classList.remove('is-open'); }
    function voegToe() { sluit(); atc.click(); }
    knop.addEventListener('click', function () {
      if (gekozen) { voegToe(); return; }
      if (!rij.hidden) { sluit(); return; }
      rij.innerHTML = '';
      radios().forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sticky-koop__maat';
        b.textContent = r.value;
        b.disabled = r.disabled || r.classList.contains('sold-out') || r.classList.contains('unavailable');
        b.addEventListener('click', function () {
          wijzigt = true;
          var label = maatBlok.querySelector('label[for="' + r.id + '"]');
          (label || r).click();
          wijzigt = false;
          gekozen = true;
          /* Broadcast zet de variant in het formulier na de change; even
             wachten zodat de juiste variant in de tas gaat. */
          setTimeout(function () { teken(); voegToe(); }, 250);
        });
        rij.appendChild(b);
      });
      rij.hidden = false;
      balk.classList.add('is-open');
    });
    var cartBar = document.getElementById('cart-bar');
    if (cartBar) new MutationObserver(function () {
      if (!cartBar.classList.contains('is-visible')) sluit();
    }).observe(cartBar, { attributes: true, attributeFilter: ['class'] });
    if (prijsEl) new MutationObserver(teken).observe(prijsEl, { childList: true, characterData: true, subtree: true });
    teken();
  }

  /* ── Order Protection (snippets/brand-bescherming) ────────────────
     Het vinkje zet het verborgen product op 1 of 0 stuks; daarna tekent
     Broadcast de tas opnieuw, met het vinkje zoals de tas het nu heeft.
     Blijft de bescherming alleen over (alles andere eruit gehaald), dan gaat
     hij er ook uit: los afrekenen kan niet de bedoeling zijn. */
  function zetBescherming(variant, aantal) {
    var upd = {};
    upd[variant] = aantal;
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: upd })
    }).then(function () {
      var items = document.querySelector('cart-items');
      if (items && typeof items.getCart === 'function') items.getCart();
    });
  }

  /* Direct tonen dat er geklikt is (14-10-2026: "beetje buggy"): het vinkje
     werd tijdens het verzoek uitgeschakeld en daarna door de herrendering
     vervangen, zodat het even grijs bleef en terugsprong. Nu blijft het
     staan zoals de klant het zette; de verzoeken lopen achter elkaar, zodat
     snel aan-uit-aan ook in die volgorde in de tas aankomt. */
  var beschermRij = Promise.resolve();
  document.addEventListener('change', function (e) {
    var vink = e.target.closest('.tas-bescherm__vink');
    if (!vink) return;
    var blok = vink.closest('[data-bescherming]');
    var aantal = vink.checked ? 1 : 0;
    blok.classList.toggle('is-aan', !!aantal);
    beschermRij = beschermRij.then(function () {
      return zetBescherming(blok.getAttribute('data-bescherming'), aantal).catch(function () {
        vink.checked = !aantal;
        blok.classList.toggle('is-aan', !aantal);
      });
    });
  });

  /* 17-10-2026: Order Protection staat uit (coach). Het vinkje is weg, dus wie
     de bescherming nog in een oude tas heeft kan hem niet meer uitzetten: die
     regel gaat er daarom altijd uit, bij het laden en na elke wijziging. */
  function haalBeschermingWeg() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bescherm = cart.items.filter(function (i) { return i.sku === 'ORDER-PROTECTION'; });
        if (bescherm.length) zetBescherming(bescherm[0].variant_id, 0);
      })
      .catch(function () {});
  }
  document.addEventListener('theme:cart:change', haalBeschermingWeg);
  haalBeschermingWeg();

  /* Maat wijzigen in de tas (17-10-2026, CRO-audit): oude regel op 0, nieuwe
     variant met hetzelfde aantal erbij, en dan de tas opnieuw tekenen zoals bij
     de Order Protection hierboven. Lukt het toevoegen niet (bijv. net
     uitverkocht), dan gaat de oude maat terug in de tas. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.tas-maat');
    if (!sel) return;
    var sleutel = sel.getAttribute('data-tas-maat');
    var aantal = parseInt(sel.getAttribute('data-aantal'), 10) || 1;
    var oud = sel.querySelector('option[selected]');
    var oudId = oud ? oud.value : null;
    var post = function (pad, body) {
      return fetch(root + pad, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); });
    };
    sel.disabled = true;
    post('cart/change.js', { id: sleutel, quantity: 0 })
      .then(function () { return post('cart/add.js', { items: [{ id: Number(sel.value), quantity: aantal }] }); })
      .catch(function () { if (oudId) return post('cart/add.js', { items: [{ id: Number(oudId), quantity: aantal }] }); })
      .then(function () {
        var items = document.querySelector('cart-items');
        if (items && typeof items.getCart === 'function') items.getCart();
        else location.reload();
      });
  });

  /* Nieuwsbriefpopup niet over de tas heen (17-10-2026): de popup komt na 10 s,
     ook als iemand net de tas open heeft of op /cart staat, en dan zat hij midden
     in het afrekenen in de weg. Opent hij op zo'n moment, dan sluit hij meteen. */
  (function () {
    var popup = document.querySelector('[data-large-promo-inner]');
    if (!popup) return;
    var tas = document.querySelector('cart-drawer');
    var check = function () {
      if (!popup.open) return;
      var bezig = (tas && tas.classList.contains('is-open')) || /\/cart(\/|$)/.test(location.pathname);
      if (!bezig) return;
      var dicht = popup.querySelector('.brand-popup__dismiss');
      if (dicht) dicht.click(); else popup.close();
    };
    /* Beide kanten: de popup gaat open terwijl de tas open is, of de tas gaat
       open (of schuift nog open) terwijl de popup er al staat. */
    new MutationObserver(check).observe(popup, { attributes: true, attributeFilter: ['open'] });
    if (tas) new MutationObserver(check).observe(tas, { attributes: true, attributeFilter: ['class'] });
  })();

  /* Kiwi Sizing (17-10-2026): Kiwi zet zijn "Size Chart"-link zelf neer (na de
     prijs) en pas nadat zijn script geladen is. Hier gaat die link direct boven
     "Size:" in het maatblok, zoals bij Harrington Oxford. Een observer, omdat
     het moment onbekend is; na 15 s stopt hij. */
  function kiwiBovenMaat() {
    var maat = document.querySelector('.selector-wrapper--size');
    if (!maat || maat.closest('#cart-bar')) return;
    /* Heeft het product een eigen maattabel (snippet brand-maattabel), dan
       gaat die op Kiwi's plek; Kiwi's eigen link is dan verborgen (css). */
    var eigen = document.querySelector('.brand-maattabel');
    if (eigen) {
      var dlg = eigen.querySelector('dialog');
      /* De dialog gaat naar body en niet mee het maatblok in (18-10-2026): zijn
         cm/inches-radio's werden anders als maten gelezen. maatVrij() pakte "cm"
         als eerste radio, vond geen koopknop en liet S aangevinkt staan (pak,
         midi-jurk); de sticky balk en de express-maatkiezer toonden "cm" en
         "in" als maat. De opmaak hangt aan de klasse, niet aan de plek. */
      document.body.appendChild(dlg);
      /* Alleen de tabellen van de gekozen kleur (zie brand-maattabel.liquid). */
      var kleurTabellen = function () {
        var groepen = [].slice.call(dlg.querySelectorAll('.brand-maattabel__groep'));
        if (!groepen.some(function (g) { return g.getAttribute('data-kleur'); })) return;
        var r = [].filter.call(document.querySelectorAll('[data-option-position="1"] input[type=radio]:checked'), function (x) {
          return !x.closest('#cart-bar') && !x.closest('dialog');
        })[0];
        var k = r ? r.value.toLowerCase() : '';
        var eigenKleur = groepen.filter(function (g) {
          var gk = g.getAttribute('data-kleur').toLowerCase();
          return gk && k && (gk.indexOf(k) === 0 || k.indexOf(gk) === 0);
        });
        var toon = eigenKleur.length ? eigenKleur : groepen.filter(function (g) { return /^other|^$/i.test(g.getAttribute('data-kleur')); });
        if (!toon.length) toon = groepen;
        groepen.forEach(function (g) { g.hidden = toon.indexOf(g) < 0; });
      };
      eigen.querySelector('.brand-maattabel__open').addEventListener('click', function () { kleurTabellen(); dlg.showModal(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.querySelector('.brand-maattabel__dicht').addEventListener('click', function () { dlg.close(); });
    }
    var zet = function () {
      var link = eigen || document.querySelector('.ks-chart-container');
      if (link && link.parentElement !== maat) maat.insertBefore(link, maat.firstChild);
    };
    zet();
    var obs = new MutationObserver(zet);
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { geenVasteMaat(); kiwiBovenMaat(); verzenddatum(); vulExtra(); maatLink(); stickyKoop(); });
  } else {
    geenVasteMaat(); kiwiBovenMaat(); verzenddatum(); vulExtra(); maatLink(); stickyKoop();
  }
})();
